export default "__VITE_ASSET__DgvUKu5q__"